import styled from 'styled-components';

import { Button as InnerButton } from '@xing-com/button';
import {
  BodyCopy as InnerBodyCopy,
  Headline as InnerHeadline,
} from '@xing-com/typography';

export const Button = styled(InnerButton)`
  align-self: center;
  padding: var(--spaceXL);
  min-width: 0px;
  margin: var(--spaceL);
`;
export const EmptyStateCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin: var(--spaceXXL) 0 0 0;
  padding: var(--spaceL) var(--spaceM) var(--spaceL) var(--spaceM);
  background-color: var(--xdlColorBackgroundSecondary);
`;

export const TextLayer = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--spaceL) var(--spaceXL);
  width: 100%;
  max-width: 510px;
`;
export const Headline = styled(InnerHeadline)`
  color: var(--xdlColorTextSecondary);
  margin-right: var(--spaceL);
`;

export const BodyCopy = styled(InnerBodyCopy)`
  color: var(--xdlColorTextSecondary);
  margin-right: var(--spaceL);
`;
